import { copyTableClean } from 'components/Dashboard/helpers/copyFunctionality';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import ManifestoShare from 'components/Temporary/Manifestos/ManifestoShare';
import React, { useRef } from 'react';

const ManifestoComparison = ({ searchValue, manifestosSelected, comparison, trackerPage, hideSummaryHeader }) => {
  const disclaimer = (
    <button
      className='text-red-dark rounded rounded-pill hovered-button general-button border-general border-grey px-3 specific-y-padding-5 paragraph-p3'
      data-tooltip-content={
        'This analysis was created by PolicyMogul\u2019s AI assistant. This feature is in Beta and output may contain factual errors.'
      }
      data-tooltip-id='tooltip-mobile'
      data-tooltip-class-name='header-tooltip disclaimer-tooltip'
      data-tooltip-place='bottom'
    >
      <span className='icon-info  mr-2 d-inline-block-centered' />
      Disclaimer
    </button>
  );

  const manifestoTable = useRef(null);

  return (
    <>
      {hideSummaryHeader ? (
        <div
          className={`py-3 ${trackerPage ? 'specific-x-padding-16 specific-x-padding-lg-30' : 'px-3 px-lg-5'}`}
          style={{ borderBottom: '1px solid #E6DFDB' }}
        >
          <div className='d-flex align-items-center justify-content-between'>
            <h4 className={`mb-0 ${trackerPage ? 'title-h4-bold' : 'title-h5-m-bold'}`}>Analysis</h4>
            <div className='flex-centered'>
              {disclaimer}
              <button
                className='general-button nowrap-item link-button mt-0 rounded px-3 ml-3 rounded-pill border paragraph-p3 specific-y-padding-6  action-state-hover'
                onClick={() => {
                  if (manifestoTable.current) {
                    copyTableClean(manifestoTable.current);
                  }
                }}
              >
                <span className='d-inline-block-centered icon-copy-thin specific-right-margin-7' /> Copy table
              </button>
              {trackerPage && (
                <div className='ml-3'>
                  <ManifestoShare election2026={true} />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={`pt-3 pb-4 pt-lg-4 px-3 px-lg-5`}>
          <div className='d-lg-flex align-items-start justify-content-between'>
            <div>
              <h4 className={`mb-2  title-h5-m-bold`}>Your search</h4>
            </div>
            <div className='flex-centered'>
              <button
                className='general-button nowrap-item link-button mt-0 rounded px-3 ml-lg-3 rounded-pill border paragraph-p3 specific-y-padding-6 action-state-hover'
                onClick={() => {
                  if (manifestoTable.current) {
                    copyTableClean(manifestoTable.current);
                  }
                }}
              >
                <span className='d-inline-block-centered icon-copy-thin specific-right-margin-7' /> Copy table
              </button>
              {trackerPage && (
                <div className='ml-lg-3'>
                  <ManifestoShare election2026={true} />
                </div>
              )}
            </div>
          </div>

          <p className='specific-top-margin-10 mb-1'>
            <span className=''>Manifestos to compare: </span>
            {manifestosSelected.map((manifesto, i) => (
              <React.Fragment key={`${manifesto.label}-${i}`}>
                {manifesto?.link ? (
                  <a href={manifesto?.link} target='_blank' rel='noopener noreferrer' className='simple-link-text mr-1'>
                    {manifesto.label}
                    {i !== manifestosSelected.length - 1 ? ',' : ''}
                  </a>
                ) : (
                  <span className='main-light-text mr-1'>
                    {manifesto.label}
                    {i !== manifestosSelected.length - 1 ? ',' : ''}
                  </span>
                )}
              </React.Fragment>
            ))}
          </p>
          <p className=' mb-0'>
            <span className='main-light-text'>"{searchValue}"</span>
          </p>
        </div>
      )}
      <div
        className={`${trackerPage ? 'flex-grow-1 d-flex flex-column overflow-auto  py-4 specific-x-padding-16 specific-x-padding-lg-30' : 'bg-blue-hovered flex-grow-1 px-3 px-lg-5 py-4'}`}
      >
        <div
          ref={manifestoTable}
          className='manifesto-compare-table'
          dangerouslySetInnerHTML={createMarkup(comparison)}
        />
      </div>
    </>
  );
};

export default ManifestoComparison;
